import React from "react";
import {
    Dialog,
    useMediaQuery,
    useTheme,
    Typography,
    Box,
    Grid,
    Divider,
    Paper
} from "@mui/material";
import { IoCloseCircleOutline } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import { openViewEnquiryDialog } from "../Redux/Dashboard/DashboardSlice";

const EnquiryViewDetails = () => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
    const dispatch = useDispatch();
    const open = useSelector((s) => s.DashboardSlice.openEnquiryDialog);
    const selected = useSelector((s) => s.DashboardSlice.selectedStudentEnquiry);

    const handleClose = () => dispatch(openViewEnquiryDialog(false));

    const renderFilePreview = (url) => {
        if (!url) return <Typography color="text.secondary">No file uploaded</Typography>;
        const ext = url.split(".").pop().toLowerCase();

        if (["jpg", "jpeg", "png", "gif", "webp", "ai"].includes(ext)) {
            return <img src={url} alt="file" style={{ maxWidth: "100%", borderRadius: 10,  height:"500px" }} />;
        }

        if (["mp4", "webm", "ogg", "mov", "avi"].includes(ext)) {
            return <video src={url} controls style={{ width: "100%", borderRadius: 10, height:"500px" }} />;
        }

        if (["pdf"].includes(ext)) {
            return (
                <object data={url} type="application/pdf" width="100%" height="500px">
                    <p>Unable to preview PDF. <a href={url} target="_blank" rel="noreferrer">Download</a></p>
                </object>
            );
        }

        return (
            <Typography>
                File: <a href={url} target="_blank" rel="noreferrer">{url}</a>
            </Typography>
        );
    };

    return (
        <Dialog
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                sx: {
                    borderRadius: 3,
                    p: 3,
                    bgcolor: "#f9f9f9",
                },
            }}
        >
            <Box>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                    <Typography variant="h5" fontWeight="bold">View Enquiry</Typography>
                    <IoCloseCircleOutline
                        size={28}
                        onClick={handleClose}
                        style={{ cursor: "pointer", color: "#f44336" }}
                    />
                </Box>

                {/* User Details */}
                <Paper elevation={2} sx={{ p: 3, borderRadius: 2, mb: 4 }}>
                    <Typography variant="h6" gutterBottom>User Details</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2">Name</Typography>
                            <Typography>{selected?.user_id?.name || "-"}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2">Email</Typography>
                            <Typography>{selected?.user_id?.email || "-"}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2">Phone</Typography>
                            <Typography>{selected?.user_id?.phone || "-"}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2">Gender</Typography>
                            <Typography>{selected?.user_id?.gender || "-"}</Typography>
                        </Grid>
                    </Grid>
                </Paper>

                {/* Enquiry Details */}
                <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
                    <Typography variant="h6" gutterBottom>Enquiry Details</Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2">Title</Typography>
                            <Typography>{selected?.title}</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <Typography variant="subtitle2">Category</Typography>
                            <Typography>{selected?.category}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2">Message</Typography>
                            <Typography>{selected?.message}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2">Status</Typography>
                            <Typography>{selected?.status}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2">Response</Typography>
                            <Typography>{selected?.response || "No response yet."}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle2">Attached File</Typography>
                            {renderFilePreview(selected?.enquiryFile)}
                        </Grid>
                    </Grid>
                </Paper>
            </Box>
        </Dialog>
    );
};

export default EnquiryViewDetails;
